export const countryMap: Record<string, Array<string>> = {
    "USAmazon": [
        "US",
        "CA",
        "MX",
        "BR",
        "CO", // Colombia
        "CL", // Chile
    ],
    "EUAmazon": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "IN",
        "AE",
        "TR",
        "SA",
        "NL",
        "SE",
        "PL",
        "EG",
        "BE",
        "ZA",
        "IE", // Ireland
        "AT", // Austria
        "DK", // Denamrk
        "PT", // Portugal
        "MC", // Monaco
        "NG"  // Nigeria
    ],
    "JPAmazon": [
        "JP",
        "AU",
        "SG",
        "ID", // Indonesia
        "TH" // Thailand
    ]
};

export enum PipelineStageEnum {
    Development = 'Development',
    BetaNA = 'Beta-NA',
    BetaEU = 'Beta-EU',
    BetaFE = 'Beta-FE',
    GammaNA = 'Gamma-NA',
    GammaEU = 'Gamma-EU',
    GammaFE = 'Gamma-FE',
    ProdNA = 'Prod-NA',
    ProdEU = 'Prod-EU',
    ProdFE = 'Prod-FE'
}

// Use Development stage for local development, otherwise use the template replacement
export const pipelineStage = process.env.NODE_ENV === 'development' ? PipelineStageEnum.Development : "Beta-NA";
